<footer class="main-footer background-black">
    <div class="main-footer__bg background-black"
        style="background-image: url(assets/images/backgrounds/footer-bg-1-1.jpg);"></div>
    <!-- /.main-footer__bg -->
     
    <div class="container">
        <div class="row">
            <div class="col-md-6 col-xl-4 wow fadeInUp" data-wow-delay="100ms">
                <div class="footer-widget footer-widget--about">
                    <a href="/" class="footer-widget__logo">
                        <img src="/logo-footer.png" width="125" alt="arp">
                    </a>
                    <p class="footer-widget__text" style="text-align: justify;font-size: 14px;">
                        {{ setting?.footer_description_text || pickLang(setting?.footer_description) || ('biofooter' | translate) }}
                    </p>
                    <div class="footer-widget__box">
                        
                    </div>
                </div><!-- /.footer-widget -->
            </div><!-- /.col-md-6 -->
            <div class="col-md-6 col-xl-2 wow fadeInUp" data-wow-delay="150ms">
                <div class="footer-widget footer-widget--links">
                    <h2 class="footer-widget__title">{{ 'Institution' | translate }}</h2><!-- /.footer-widget__title -->
                    <ul class="list-unstyled footer-widget__links">
                        <li style="display: none;"><a [routerLink]="['/autorite/bureau']"><i class="fas fa-chevron-right"></i>{{ 'autorite_menu_bureau' | translate }}</a></li>
                        <li><a [routerLink]="['/autorite/comites']"><i class="fas fa-chevron-right"></i>{{ 'autorite_menu_comites' | translate }}</a></li>
                        <li><a [routerLink]="['/autorite/anciens-presidents']"><i class="fas fa-chevron-right"></i>{{ 'autorite_menu_anciens' | translate }}</a></li>
                        <li><a [routerLink]="['/loi']"><i class="fas fa-chevron-right"></i>{{ 'loi_menu' | translate }}</a></li>
                    </ul><!-- /.list-unstyled footer-widget__links -->
                </div><!-- /.footer-widget -->
            </div><!-- /.col-md-6 -->
            <div class="col-md-6 col-xl-3 wow fadeInUp" data-wow-delay="200ms">
                <div class="footer-widget footer-widget--links-two">
                    <h2 class="footer-widget__title">{{ 'Services' | translate }}</h2><!-- /.footer-widget__title -->
                    <ul class="list-unstyled footer-widget__links">
                        <li><a href="/annuaire"  ><i class="fas fa-chevron-right"></i>{{ 'footer_accreditation' | translate }}</a></li>
                        <li><a [routerLink]="['/signalement']"  ><i class="fas fa-chevron-right"></i>{{ 'footer_signalement' | translate }}</a></li>
                        <li><a [routerLink]="['/plainte']"  ><i class="fas fa-chevron-right"></i>{{ 'plainte_menu_deposer' | translate }}</a></li>
                        <li><a href="https://center.arp.gov.mr" ><i class="fas fa-chevron-right"></i>{{ 'footer_licences' | translate }}</a></li>
                        <li><a href="https://arp.gov.mr/#arp-map" ><i class="fas fa-chevron-right"></i>{{ 'footer_carte_pub' | translate }}</a></li>

                         
                    </ul><!-- /.list-unstyled footer-widget__links -->
                </div><!-- /.footer-widget -->
            </div><!-- /.col-md-6 -->
            <div class="col-md-6 col-xl-3 wow fadeInUp" data-wow-delay="250ms">
                <div class="footer-widget footer-widget--contact">
                    <h2 class="footer-widget__title">{{ 'contact' | translate }}</h2><!-- /.footer-widget__title -->
                    <ul class="list-unstyled footer-widget__info">
                        <li *ngIf="setting?.adresse_text || pickLang(setting?.adresse)" style="--accent-color: #ff5528;">
                            <span class="footer-widget__info__icon"><i class="icofont-location-pin"></i></span>
                            {{ setting?.adresse_text || pickLang(setting?.adresse) }}
                        </li>
                        <li *ngIf="setting?.telephone" style="--accent-color: #ffa415;">
                            <span class="footer-widget__info__icon"><i class="icofont-phone"></i></span>
                            <a href="tel:{{ setting?.telephone }}">{{ setting?.telephone }}</a>
                        </li>
                        <li *ngIf="setting?.email" style="--accent-color: #8139e7;">
                            <span class="footer-widget__info__icon"><i class="icofont-email"></i></span>
                            <a href="mailto:{{ setting?.email }}">{{ setting?.email }}</a>
                        </li>
                    </ul><!-- /.list-unstyled -->
                    <div class="footer-widget__social">
                        <a *ngIf="setting?.facebook" [href]="setting?.facebook" target="_blank" rel="noopener" style="--accent-color: #3b5998;">
                            <i class="fab fa-facebook-f" aria-hidden="true"></i>
                            <span class="sr-only">Facebook</span>
                        </a>
                        <a *ngIf="setting?.linkedin" [href]="setting?.linkedin" target="_blank" rel="noopener" style="--accent-color: #0A66C2;">
                            <i class="fa-brands fa-square-linkedin"></i>
                            <span class="sr-only">LinkedIn</span>
                        </a>
                        <a *ngIf="setting?.twitter" [href]="setting?.twitter" target="_blank" rel="noopener" style="--accent-color: #000000;">
                            <i class="fa-brands fa-square-x-twitter"></i>
                            <span class="sr-only">Twitter</span>
                        </a>
                        <a *ngIf="setting?.instagram" [href]="setting?.instagram" target="_blank" rel="noopener" style="--accent-color: #E1306C;">
                            <i class="fa-brands fa-square-instagram"></i>
                            <span class="sr-only">Instagram</span>
                        </a>
                    </div><!-- /.footer-widget__social -->
                </div><!-- /.footer-widget -->
            </div><!-- /.col-md-6 -->
        </div><!-- /.row -->
    </div><!-- /.container -->
    <div class="main-footer__bottom wow fadeInUp" data-wow-delay="300ms">
        <div class="container">
            <div class="main-footer__bottom__inner">
                <!-- dir="auto" : le navigateur déduit le sens depuis le 1er caractère fort
                     (latin -> LTR, arabe -> RTL). Sans ça, en mode RTL le « © » et le point
                     final sont déplacés aux mauvaises extrémités par l'algorithme bidi. -->
                <p class="main-footer__copyright" dir="auto">
                    {{ 'footer_copyright' | translate:{ year: year, site: setting?.site_title || 'ARP' } }}
                </p>
            </div><!-- /.main-footer__inner -->
        </div><!-- /.container -->
    </div><!-- /.main-footer__bottom -->
</footer><!-- /.main-footer -->
